import { Box, Text, TextProps } from '@chakra-ui/react';
import React from 'react';
import { ReactComponent as RoundedStar } from '../../Assets/images/icons/rounded-star.svg';

interface Props {
  color: string;
  ratingScore: number;
  textColor?: string;
  textProps?: TextProps;
}

const RatingStar: React.FC<Props> = ({
  color,
  ratingScore,
  textColor,
  textProps = {}
}) => {
  return (
    <Box display="flex" alignItems="baseline">
      <RoundedStar fill={color} />
      <Text
        mx="2px"
        fontSize="11px"
        fontWeight="700"
        textTransform="uppercase"
        lineHeight="15px"
        color={textColor ?? 'var(--neutral-600)'}
        {...textProps}
      >
        {ratingScore && Math.round(ratingScore * 10) / 10}
      </Text>
    </Box>
  );
};

export default RatingStar;
